import { ChangeDetectorRef, Component, HostBinding } from '@angular/core';
import { EntityType, HelpIndex } from '../../models/enums';
import { ExportStream } from '../../models/export-stream';
import { ExportVolume } from '../../models/export-volume';
import { NavigationContentComponent } from '../../models/navigation-content-component';
import { CommonService } from '../../services/common/common.service';
import { RestService } from '../../services/rest/rest.service';
import { GenericTreeNode } from '../generic-tree/generic-tree-node';

@Component({
    standalone: false,
    selector: 'res-export-stream-volume-settings',
    templateUrl: './export-stream-volume-settings.component.html',
    styleUrls: ['./export-stream-volume-settings.component.scss']
})
export class ExportStreamVolumeSettingsComponent implements NavigationContentComponent {
    @HostBinding('class') classes = 'maximized-component';

    automationId: string;
    localHelpIndex: HelpIndex;
    selectedExportStream: ExportStream;
    selectedExportVolume: ExportVolume;
    isBusy = true;
    isBusyMessage = 'Loading...';
    status: string;

    constructor(private restService: RestService, private commonService: CommonService, private changeDetector: ChangeDetectorRef) { }

    selectedTreeItemChanged = (node: GenericTreeNode) => {
        if (node) {
            if (node.entityType === EntityType.export && node.data instanceof ExportStream) {
                this.automationId = 'export-stream-settings';
                this.localHelpIndex = HelpIndex.exports_ediscexports_stream_settings_dlg;
                this.selectedExportStream = node.data;
            } else if (node.entityType === EntityType.exportVolume && node.data instanceof ExportVolume && node.parent && node.parent.data instanceof ExportStream) {
                this.automationId = 'export-volume-settings';
                this.localHelpIndex = HelpIndex.exports_ediscexports_vol_settings_dlg;
                this.selectedExportVolume = node.data;
                this.selectedExportStream = node.parent.data;
            }
            this.status = this.selectedExportVolume ? this.selectedExportVolume.stateDisplay :
                this.selectedExportStream ? this.selectedExportStream.stateDisplay : '';
        }
    }

    openHelp = () => this.commonService.openHelp(this.localHelpIndex);
}
